import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../Router/LanguageContext";

export default function EsgSection() {
  const { dictionary } = useLanguage();

  const esgData = [
    {
      number: "01",
      title: dictionary?.environmentalTitle,
      description: dictionary?.environmentalDesc,
    },
    {
      number: "02",
      title: dictionary?.socialTitle,
      description: dictionary?.socialDesc,
    },
    {
      number: "03",
      title: dictionary?.governanceTitle,
      description: dictionary?.governanceDesc,
    },
  ];
  return (
    <div className="container-fluid maxContainerSection commonPadding">
      <div className="row">
        <div className="col-md-12 whowearehedaersection ourSolutionSectionHeader">
          <h2 className="m-0 f-s-48">{dictionary?.esgTitle}</h2>
          <p className="m-0 f-s-20 ">{dictionary?.esgDescription}</p>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <motion.img
            src="/assets/img/esgimageNew.png"
            className="img-fluid"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          />
        </div>
        <div className="col-md-6 esgRightSection">
          {esgData.map((item, index) => (
            <div className="esgSection" key={index}>
              <div className="f-s-48 esgNumber">{item.number}</div>

              <div className="esgContent">
                <h6 className="m-0 f-s-20">{item.title}</h6>
                <p className="m-0 f-s-18">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
